module.exports = __webpack_public_path__ + "static/img/lb_img_4.541b7af9.png";